export const ROUTE_NAME = {
  Home: "Home",
  Sna: "Sna",
  Gis: "Gis",
  Help: "Help",
  LogIn: "LogIn",
  LogOut: "LogOut",
  Signup: "Signup",
  Shop: "Shop",
  UserSetting: "UserSetting",
  AdminSetting: "AdminSetting",
  RootSetting: "RootSetting",
  ErrorPage: "ErrorPage",
  SupportPage: "SupportPage",
  ServicePage: "ServicePage",
  PrivacyPage: "PrivacyPage",
  InvitePage: "InvitePage",
};

export const ROUTE_PATH = {
  Home: "/:locale",
  Console: "/:locale/sna", // 主控台:預設 sna page
  Sna: "/:locale/sna",
  digitalAI: "/:locale/digitalAI",
  Gis: "/:locale/gis",
  Help: "/:locale/help",
  LogIn: "/:locale/login",
  LogOut: "/:locale/logout",
  Signup: "/:locale/signup",
  Shop: "/:locale/shop",
  UserSetting: "/:locale/usersetting",
  AdminSetting: "/:locale/adminSetting",
  RootSetting: "/:locale/rootSetting",
  ErrorPage: "/:locale/error",
  SupportPage: "/:locale/support",
  ServicePage: "/:locale/service",
  PrivacyPage: "/:locale/privacy",
  InvitePage: "/:locale/invitation",
};

export const MODULE_ID = {
  /* home page */

  /* sna page */
  // side toolbar
  snaSidetoolGroup: "sna_sidetool_group",
  snaSidetoolDataset: "sna_sidetool_dataset",
  snaSidetoolDigitalAI: "sna_sidetool_digitalAI",
  snaSidetoolAdjust: "sna_sidetool_adjust",
  snaSidetoolFilter: "sna_sidetool_filter",
  snaSidetoolAnalytics: "sna_sidetool_analytics",
  snaSidetoolEvnCtgSetting: "sna_sidetool_evnCtgSetting",
  snaSidetoolHelp: "sna_sidetool_help",
  // sidebar
  // groupTool
  snaSidebarGroup: "sna_sidebar_group",
  snaSidebarGroupAddmember: "sna_sidebar_group_addmember",
  snaSidebarGroupEditmember: "sna_sidebar_group_editmember",
  snaSidebarGroupsAddgroup: "sna_sidebar_groups_addgroup",
  snaSidebarGroupsEditgroup: "sna_sidebar_groups_editgroup",
  // fileTool
  snaSidebarFile: "sna_sidebar_file",
  snaSidebarFilePersonal: "sna_sidebar_file_personal",
  snaSidebarFilePersonalDatasetShare: "sna_sidebar_file_personal_dataset_share",
  snaSidebarFileGroup: "sna_sidebar_file_group",
  snaSidebarFileGroupPublic: "sna_sidebar_file_group_public",
  snaSidebarFileGroupPrivate: "sna_sidebar_file_group_private",
  snaSidebarFileGroupPrivateEdit: "sna_sidebar_file_group_private_edit",
  // adjustTool
  snaSidebarAdjust: "sna_sidebar_adjust",
  snaSidebarAdjustNodeColor: "sna_sidebar_adjust_node_color",
  snaSidebarAdjustLinkColor: "sna_sidebar_adjust_link_color",
  snaSidebarAdjustPlacement: "sna_sidebar_adjust_placement",
  snaSidebarAdjustNodeDispersion: "sna_sidebar_adjust_node_dispersion",
  snaSidebarAdjustNodeShowCount: "sna_sidebar_adjust_node_show_count",
  snaSidebarAdjustApplySetting: "sna_sidebar_adjust_apply_setting",
  snaSidebarAdjustClearSetting: "sna_sidebar_adjust_clear_setting",
  // filterTool
  snaSidebarFilter: "sna_sidebar_filter",
  snaSidebarFilterNode: "sna_sidebar_filter_node",
  snaSidebarFilterLink: "sna_sidebar_filter_link",
  snaSidebarFilterTimePeriod: "sna_sidebar_filter_time_period",
  snaSidebarFilterStartEndDate: "sna_sidebar_filter_start_end_date",
  snaSidebarFilterNodeCountMeetAuth: "sna_sidebar_filter_node_count_meet_auth",
  snaSidebarFilterApplySetting: "sna_sidebar_filter_apply_setting",
  snaSidebarFilterClearSetting: "sna_sidebar_filter_clear_setting",
  // analyticsTool
  snaSidebarAnalytics: "sna_sidebar_analytics",
  snaSidebarAnalyticsCentrality: "sna_sidebar_analytics_centrality",
  snaSidebarAnalyticsGraphDensity: "sna_sidebar_analytics_graph_density",
  snaSidebarAnalyticsPageRank: "sna_sidebar_analytics_page_rank",

  // top panel
  snaTopPanelImport: "sna_toppanel_import",
  snaTopPanelExport: "sna_toppanel_export",
  snaTopPanelExportFile: "sna_toppanel_export_file",
  snaTopPanelExportFileFormat: "sna_toppanel_export_file_format",
  snaTopPanelExportImage: "sna_toppanel_export_image",
  snaTopPanelExportImageFormat: "sna_toppanel_export_image_format",
  snaTopPanelExportImageResolution: "sna_toppanel_export_image_resolution",
  snaTopPanelDataset: "sna_toppanel_dataset",

  /* gis page */
  gisPageLink: "gis_page_link",
  /* help page */
  // help basic
  helpPageLink: "help_page_link",
  helpBasic: "help_basic",
  helpBasicSignin: "help_basic_signin",
  helpBasicSignout: "help_basic_signout",
  helpBasicImport: "help_basic_import",
  helpBasicExport: "help_basic_export",
  helpBasicGroup: "help_basic_group",
  helpBasicFile: "help_basic_file",
  helpBasicAdjust: "help_basic_adjust",
  helpBasicFilter: "help_basic_filter",
  helpBasicAnalytics: "help_basic_analytics",
  // help account
  helpAccount: "help_account",
  // help common
  helpCommon: "help_common",

  /* user setting */
  userSettingPageLink: "user_setting_page_link",
  /* admin setting */
  adminSettingPageLink: "admin_setting_page_link",
  /* root setting */
  rootSettingPageLink: "root_setting_page_link",
  /* shop page */
  shopPageLink: "shop_page_link",
  /* privacy page */
  privacyPageLink: "privacy_page_link",
  /* service page */
  servicePageLink: "service_page_link",
};

export const MODULE_LIMIT_ID = {
  /* sna page */
  // group tool
  CREATE_GROUPS_COUNT_MAX_LIMIT: "CREATE_GROUPS_COUNT_MAX_LIMIT",
  ADMINS_OF_ONE_GROUP_MAX_LIMIT: "ADMINS_OF_ONE_GROUP_MAX_LIMIT",
  ADMINS_OF_ONE_GROUP_MIN_LIMIT: "ADMINS_OF_ONE_GROUP_MIN_LIMIT",
  USERS_OF_ONE_GROUP_MAX_LIMIT: "USERS_OF_ONE_GROUP_MAX_LIMIT",

  // dataset tool

  // filter tool

  // adjust tool

  // analytics tool

  // import tool

  // export tool
};

// 對照 console 的方法
export const LOG_CLASSIFICATION = {
  log: "log", // 範圍：系統 log,參考 LOG_CODE
  info: "info", // 範圍：使用者操作,參考 INFO_CODE
  warning: "warning", // 範圍：各式警告訊息,參考 WARNING_CODE
  error: "error", // 範圍：各式錯誤訊息,參考 ERROR_CODE
};

export const LOG_CODE = {
  systemLog: "log_system",
};

export const INFO_CODE = {
  systemInfo: "info_system",
};

export const WARNING_CODE = {
  systemWarning: "warning_system",
};

// 儲存在 realtime database 或 api 的 error code
export const ERROR_CODE = {
  systemCrashError: "error_system_crash",
  userCreateError: "error_user_create",
  userUpdateError: "error_user_update",
  userDeleteError: "error_user_delete",
  userLoginError: "error_user_login",
};
